const CONSTANCE_IMG_URL =
  'https://sherpas-prod.s3.eu-west-3.amazonaws.com/landing/constance.png';

export default CONSTANCE_IMG_URL;
